<!-- 公寓门锁设置页面 -->
<template>
  <div class="page" style="text-align: left" v-loading="loading">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="设备编号">
        <el-input v-model="form.devNum" disabled></el-input>
      </el-form-item>
      <el-form-item label="设备ID">
        <el-input v-model="form.devMAC" disabled></el-input>
      </el-form-item>
      <el-form-item label="设备电量">
        <el-row>
          <el-col :span="3">
            <el-input v-model="form.battery" disabled></el-input>
          </el-col>
          <el-col :span="21">
            <div style="color:#5fb878;margin-left:10px;font-size:13px;">{{form.batteryTime ? form.batteryTime + "更新" : ""}}</div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="钥匙到期">
        <el-col :span="11">
          <el-date-picker
            v-model="form.date"
            type="datetime"
            :disabled="dateDisabled"
            placeholder="选择日期时间">
          </el-date-picker>
          <!-- <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="form.date"
            style="width: 100%"
          ></el-date-picker> -->
        </el-col>
        <!-- <el-col class="line" :span="2" style="text-align: center">-</el-col>
        <el-col :span="11">
          <el-time-picker
            placeholder="选择时间"
            v-model="form.time"
            style="width: 100%"
          ></el-time-picker>
        </el-col> -->
      </el-form-item>
      <el-form-item label="授权方式">
        <el-radio-group v-model="form.authType" @change="changeRadio">
          <el-radio label="手动授权"></el-radio>
          <el-radio label="房租授权"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="二次授权">
        <el-row>
          <el-col :span="3">
            <el-switch v-model="form.secondAuth"></el-switch>
          </el-col>
          <el-col :span="21">
            <div style="color:red;font-size:13px;">* 二次授权开启后，租客可自行添加临时授权</div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="临时授权">
        <el-tag
          style="cursor:pointer;"
          :key="tag.id"
          v-for="tag in userList"
          closable
          :type="tag.state=='已过期'?'info':tag.state=='生效中'?'success':''"
          :disable-transitions="false"
          @click="editUser(tag)"
          @close="handleClose(tag)">
          {{tag.authUserName}}
        </el-tag>
        <el-tag  @click="showInput" style="cursor:pointer;">+</el-tag>
           <!-- <el-button  class="button-new-tag" size="mini">添加临时授权</el-button> -->
       

      </el-form-item>
      <el-form-item style="text-align: left">
        <el-button type="primary" @click="preservation">保存</el-button>
        <el-button type="warning" @click="relieve">解绑</el-button>
      </el-form-item>
    </el-form>
    <!-- 添加租客的弹框 -->

    <el-dialog  :title="addUserFrom.id?'编辑临时授权':'添加临时授权'"  :visible.sync="dialogVisible"  width="80%"  :before-close="handleClose1" @closed="closeDialog('addUserFrom')">
      <div>
        <el-form ref="addUserFrom" :model="addUserFrom" :rules="rules"  label-width="120px">
          <el-row>
             <el-col :span="12">
               <el-form-item label="用户姓名" prop="authUserName">
                  <el-input v-model="addUserFrom.authUserName"></el-input>
                </el-form-item>
             </el-col>
              <el-col :span="12">
                <el-form-item label="用户电话" prop="authUserPhone">
                  <el-input v-model="addUserFrom.authUserPhone"></el-input>
                </el-form-item>
              </el-col>
          </el-row>
           
            <el-form-item label="授权时间" prop="authStart">
                <el-date-picker  v-model="shouquanTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                @change="changeTime"  value-format="timestamp"></el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="授权开始时间" prop="authStart">
               <el-date-picker v-model="addUserFrom.authStart" type="datetime"  format="yyyy-MM-dd  HH:mm:ss" value-format="timestamp">  </el-date-picker>
            </el-form-item>
            <el-form-item label="授权结束时间" prop="authEnd">
              <el-date-picker v-model="addUserFrom.authEnd" type="datetime"  format="yyyy-MM-dd  HH:mm:ss" value-format="timestamp"> </el-date-picker>
            </el-form-item> -->
            <el-form-item label="授权开锁次数" >
               <el-radio-group v-model="kaisuoRadio" @change="kaisuoChange">
                 <el-radio label="2">无限次数</el-radio>
                 <el-radio label="1">有限次数</el-radio>
               </el-radio-group>
            </el-form-item>
             <el-form-item label="授权开锁次数" prop="authTimes" v-show = "kaisuoRadio==1">
              <el-input v-model="addUserFrom.authTimes"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="addUserFrom.comment"></el-input>
            </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('addUserFrom')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { Loading } from 'element-ui';
import Utils from "../../Utils";
export default {
  data() {
    return {
      kaisuoRadio:'2',//开锁次数
      shouquanTime:[],
      dateDisabled:true,
      loading:true,
      devID: "",
      form: {
        devNum: "",
        devMAC: "",
        battery: "",
        batteryTime: "",
        date: "",
        time: "",
        authType: "",
        secondAuth: false,
      },
      addUserFrom:{
        authUserName:'',
        authUserPhone:'',
        authStart:'',
        authEnd:'',
        authTimes:'',
        comment:'',//备注
      },
      rules: {
        authUserName: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
         authUserPhone:[ { required: true, message: '请输入用户电话', trigger: 'blur' },],
        authStart:[ { required: true, message: '请输入授权开始时间', trigger: 'blur' },],
        authEnd:[ { required: true, message: '请输入授权结束时间', trigger: 'blur' },],
        authTimes:[ { required: true, message: '请输入授权开锁次数', trigger: 'blur' },],
      },
      userList:[],
      inputValue: '',
      dialogVisible: false,
    };
  },
  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");
    this.devID = this.$route.query.devID;
    this.getEquipmentDetails();
    this.getTmpkeyauths();
  },

  methods: {
    // 切换授权时间
    changeTime(e){ 
        this.shouquanTime = e
        this.addUserFrom.authStart = e[0]
        this.addUserFrom.authEnd = e[1]
    },
    // 切换开锁次数
    kaisuoChange(e){ 
    },
    // 获取设备详情
    getEquipmentDetails(){
      var that = this;
      let data = {
        orgID	:this.$route.query.orgID,
        houseID	:this.$route.query.houseID,
        devID:this.devID,
      }
       axios({
        method: "post",
        url: 'houses/devices/detail',
        data: data
      }).then(value => {
          let message = value.data.message;
          if (value.data.code == 0) {
            that.form.devNum =  value.data.data.devNum;
            that.form.devMAC =   value.data.data.mac;
            that.form.battery =   value.data.data.latestBattery;
            that.form.batteryTime = Utils.long2second(value.data.data.latestBatteryTime * 1000);
            that.form.date =   new Date(value.data.data.keyAuthEnd * 1000);
            // that.form.time =   value.data.data.;
            that.form.authType =   value.data.data.keyAuthType;
            that.form.secondAuth =   value.data.data.secondAuthEnabled;
             if(value.data.data.keyAuthType== "手动授权"){
               that.dateDisabled = false
             }
            this.$message({
                message: '获取设备详情成功',
                type: 'success'
              });
          } else {
            this.$message.error('获取失败');
          }
        }).catch(e => {
          this.$message.error('失败');
        }).finally(() => {

        });
    },
    // 改变单选框
    changeRadio(e){
      if(e=='手动授权'){
        this.dateDisabled = false;
      }else{
        this.dateDisabled = true;
      }
    },
    // 获取临时钥匙授权
    getTmpkeyauths(){
      var that = this;
      that.loading = true;
      let data = {
        orgID	:this.$route.query.orgID,
        devID:this.devID,
        bindID:this.$route.query.houseID,
        NameOrPhone:'',
        state:'未取消',
        pageIdx:0,
        pageSize:100,
      }
       axios({
        method: "post",
        url: '/tmpkeyauths',
        data: data
      }).then(value => {
          if (value.data.code == 0) {
            that.userList = {...value.data.data};

          } else {
            this.$message.error(value.data.message);
          }
        }).catch(e => {
          this.$message.error('失败');
        }).finally(() => {
             that.loading = false;
        });
    },
    // 添加租客弹框确定按钮
     submitForm(addUserFrom) {
       if(this.kaisuoRadio == 2){
            this.addUserFrom.authTimes = 0
          }
        this.$refs[addUserFrom].validate((valid) => {

          if (valid) { 
           var that = this;
             const loading = this.$loading({
              lock: true,
              text: '正在请求中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            let url1 = '/tmpkeyauths/add'
            if(this.addUserFrom.id){
              url1 ='/tmpkeyauths/edit'
            }
            axios({
              method: "post",
              url: url1,//edit
              data: {
                id: this.addUserFrom.id,
                devID: this.devID,
                bindType: '房源',
                bindID: this.$route.query.houseID,
                orgID: this.$route.query.orgID,
                authTimes: parseInt(this.addUserFrom.authTimes),
                authStart: parseInt(this.addUserFrom.authStart/1000),
                authEnd: parseInt(this.addUserFrom.authEnd/1000),
                authUserName:this.addUserFrom.authUserName,
                authUserPhone:this.addUserFrom.authUserPhone,
                comment:this.addUserFrom.comment,//备注
              }
            }).then(value => {
                let message = value.data.message;
                if (value.data.code == 0) {
                   that.getTmpkeyauths();
                   that.dialogVisible = false;
                   if(that.addUserFrom.id){
                      this.$message({
                      message: '修改成功',
                      type: 'success'
                    });
                   }else{
                       this.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                   }
                 
                } else {
                  this.$message.error(value.data.message);
                }

              }).catch(e => {
               this.$message.error('失败');
              }).finally(() => {
                  loading.close();
              });
          } else { 
            return false;
          }
        });
      },
      // 弹框关闭的回调
      closeDialog(addUserFrom){
        this.$refs[addUserFrom].resetFields();
        this. kaisuoRadio = '2';//默认开锁次数为无限次数
        this.shouquanTime= [];
      },
      // 删除
    handleClose(tag) {
      var that = this;
      this.$confirm('此操作将删除 '+ tag.authUserName +' 的临时授权, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let userDel = tag;
         const loading = this.$loading({
              lock: true,
              text: '正在请求中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
         axios({
              method: "post",
              url: '/tmpkeyauths/delete',
              data: {
                id:userDel.id,
                orgID:userDel.orgID
              }
            }).then(value => {
                let message = value.data.message;
                if (value.data.code == 0) {
                   that.getTmpkeyauths();
                  this.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                } else {
                  this.$message.error('失败');
                }
              }).catch(e => {
                this.$message.error('失败');
              }).finally(() => {
                loading.close();
              });
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });

      },
      // 新增租客按钮
      showInput() {
        this.addUserFrom = {
          authUserName:'',
          authUserPhone:'',
          authStart:'',
          authEnd:'',
          authTimes:'',
          comment:'',//备注
        },
        this.dialogVisible = true;
      },
      // 修改租客信息
    editUser(tag){
      var that = this;
      this.addUserFrom = {...tag};
        this.shouquanTime.push(this.addUserFrom.authStart*1000);
      this.shouquanTime.push(this.addUserFrom.authEnd*1000);
       this.addUserFrom.authStart =  this.addUserFrom.authStart*1000;
       this.addUserFrom.authEnd =  this.addUserFrom.authEnd*1000;
       if (this.addUserFrom.authTimes == 0) {
         this.kaisuoRadio = '2' // 无限次数
       } else {
         this.kaisuoRadio = '1' // 有限次数
       }
      this.dialogVisible = true;
    },
      // 关闭弹框
      handleClose1(done) {
            done();
      },
      // 保存按钮
      preservation(){ 
        var that = this;
        var ercishouquan = '';
        if(that.form.secondAuth){
          ercishouquan = '开启'
        }else{
          ercishouquan = '关闭'
        }
         const loading = this.$loading({
              lock: true,
              text: '正在请求中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
         axios({
              method: "post",
              url: '/houses/devices/edit',
              data: {
                orgID:this.$route.query.orgID,
                houseID:this.$route.query.houseID,
                devID	:this.devID,
                keyAuthType	:that.form.authType, 
                keyAuthEnd:parseInt(that.form.date.getTime()/1000),
                secondAuthEnabled:ercishouquan,
              }
            }).then(value => {
                let message = value.data.message;
                if (value.data.code == 0) {
                  this.$message({
                      message: '保存成功',
                      type: 'success'
                    });
                } else {
                  this.$message.error('失败');
                }
              }).catch(e => {
                this.$message.error('失败');
              }).finally(() => {

                  loading.close();
              });
      },
      // 解绑按钮
      relieve(){
        var that = this;
        this.$confirm('此操作将会解绑该设备, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
              lock: true,
              text: '正在请求中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
        axios({
              method: "post",
              url: '/houses/devices/unbind',
              data: {
                orgID:this.$route.query.orgID,
                houseID:this.$route.query.houseID,
                devID	:this.devID,
              }
            }).then(value => {
                let message = value.data.message;
                if (value.data.code == 0) {
                   this.$message({
                      message: '解绑成功',
                      type: 'success'
                    });
                } else {
                  this.$message.error('失败');
                }
              }).catch(e => {
                this.$message.error('失败');
              }).finally(() => {
                 loading.close();
              });
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });

      }
  },
};
</script>
<style scoped lang="scss" >
@import "../../style.css";
 .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 30px;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>